var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVoice(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.5,
    height: 22.5,
    viewBox: "0 0 22.5 22.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "microphone_16415430",
    transform: "translate(-1.75 -1.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8679",
    "data-name": "Path 8679",
    d: "M2.917,7.794a.917.917,0,0,0,.917-.917V3.833H6.877A.917.917,0,1,0,6.877,2H2.917A.917.917,0,0,0,2,2.917v3.96a.917.917,0,0,0,.917.917Z",
    stroke: "#fcfcfc",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8680",
    "data-name": "Path 8680",
    d: "M2.917,25.473h3.96a.917.917,0,1,0,0-1.833H3.833V20.6A.917.917,0,0,0,2,20.6v3.96a.917.917,0,0,0,.917.917Z",
    transform: "translate(0 -1.473)",
    stroke: "#fcfcfc",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8681",
    "data-name": "Path 8681",
    d: "M24.557,2H20.6a.917.917,0,0,0,0,1.833H23.64V6.877a.917.917,0,1,0,1.833,0V2.917A.917.917,0,0,0,24.557,2Z",
    transform: "translate(-1.473 0)",
    stroke: "#fcfcfc",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8682",
    "data-name": "Path 8682",
    d: "M24.557,19.68a.917.917,0,0,0-.917.917V23.64H20.6a.917.917,0,0,0,0,1.833h3.96a.917.917,0,0,0,.917-.917V20.6A.917.917,0,0,0,24.557,19.68Z",
    transform: "translate(-1.473 -1.473)",
    stroke: "#fcfcfc",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8683",
    "data-name": "Path 8683",
    d: "M19.332,11.6a.917.917,0,0,0-.917.917,5.04,5.04,0,0,1-10.08,0,.917.917,0,1,0-1.833,0,6.879,6.879,0,0,0,5.957,6.8v1.81H11.345a.917.917,0,0,0,0,1.833h4.061a.917.917,0,1,0,0-1.833H14.292v-1.81a6.879,6.879,0,0,0,5.957-6.8.917.917,0,0,0-.917-.917Z",
    transform: "translate(-0.375 -0.8)",
    stroke: "#fcfcfc",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8684",
    "data-name": "Path 8684",
    d: "M17.154,11.885V7.47a3.47,3.47,0,1,0-6.939,0v4.415a3.47,3.47,0,1,0,6.939,0Zm-5.106,0V7.47a1.636,1.636,0,1,1,3.272,0v4.415a1.636,1.636,0,1,1-3.272,0Z",
    transform: "translate(-0.685 -0.167)",
    stroke: "#fcfcfc",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoice);
export default __webpack_public_path__ + "static/media/voice.51a11960.svg";
export { ForwardRef as ReactComponent };